<template>
    <MarketingCampaignCountdown v-if="store.marketingCampaign?.marketing_campaign_counter"
                                :counter="store.marketingCampaign.marketing_campaign_counter" />
    <MarketingCampaignPopup v-if="store.marketingCampaign?.marketing_campaign_popup"
                            :popup="store.marketingCampaign.marketing_campaign_popup"
                            :marketingCampaign="store.marketingCampaign" />
</template>

<script setup lang="ts">
    import { onMounted } from 'vue';
    import { useMarketingCampaignStore } from '../store/marketing-campaigns/MarketingCampaignsStore';
    import MarketingCampaignCountdown from './MarketingCampaignCountdown.vue';
    import MarketingCampaignPopup from './MarketingCampaignPopup.vue';

    interface Props {
        routeName?: string;
        resourceAlias?: string;
        resourceSlug?: string;
    }
    const props = withDefaults(defineProps<Props>(), {
        routeName: undefined,
        resourceAlias: undefined,
        resourceSlug: undefined,
    });

    const store = useMarketingCampaignStore();

    onMounted(async () => {
        const urlParams = new URLSearchParams(window.location.search);
        const countryCode = urlParams.get('country_code');
        await store.fetchMarketingCampaignData(props.routeName, props.resourceAlias, props.resourceSlug, countryCode);
    });
</script>
